/** TanStack Query keys of the service dictionaries. */

import type { CatalogListParams } from '../types/serviceSetupTypes';

export const serviceSetupKeys = {
  all: ['service-setup'] as const,
  workTypes: (includeArchived: boolean) =>
    [...serviceSetupKeys.all, 'work-types', includeArchived] as const,
  catalog: (params: CatalogListParams) => [...serviceSetupKeys.all, 'catalog', params] as const,
  catalogAll: () => [...serviceSetupKeys.all, 'catalog'] as const,
  staff: (includeInactive: boolean) => [...serviceSetupKeys.all, 'staff', includeInactive] as const,
  staffAll: () => [...serviceSetupKeys.all, 'staff'] as const,
  linkableUsers: () => [...serviceSetupKeys.all, 'linkable-users'] as const,
  resources: () => [...serviceSetupKeys.all, 'resources'] as const,
  locations: () => [...serviceSetupKeys.all, 'locations'] as const,
  statuses: () => [...serviceSetupKeys.all, 'statuses'] as const,
  settings: () => [...serviceSetupKeys.all, 'settings'] as const,
};
